export var TooltipSyntax;
(function (TooltipSyntax) {
    TooltipSyntax["Text"] = "text";
    TooltipSyntax["Markdown"] = "markdown";
})(TooltipSyntax || (TooltipSyntax = {}));
